var render = function render(){var _vm=this,_c=_vm._self._c;return _c(`v-${_vm.data.inputType}`,{tag:"component",attrs:{"id":_vm.data.inputType,"data":_vm.data,"label":_vm.data.label},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }